import React, { useMemo } from "react";
import { Table, Empty } from "@bedrock/components";
import { enums } from "services";
import NoData from '@bedrock/components/es/Empty/images/small/NoData'
import _ from "lodash";
import "./index.less"


const cloumns = [
    {
        key: "type",
        dataIndex: "type",
        title: "供应商类型",
        align: "left",
        render: (v: any) => {
            const value = enums.ValidChannelSupplierTypeEnum.pick(v + '')
            return <div>{value?.name}</div>
        }
    },
    {
        key: "valid_date",
        dataIndex: "valid_date",
        title: "生效日期",
        align: "left",
        render: (v: any) => {
            return <div>{v}</div>
        }
    },
    {
        key: "invalid_date",
        dataIndex: "invalid_date",
        title: "有效期",
        align: "left",
        render: (v: any) => {
            return <div>{v}</div>
        }
    }
]

const SupplierType = (props: any) => {
    const { newSupplierDetail } = props
    const data = useMemo(() => {
        if (_.isEmpty(newSupplierDetail?.type_info)) {
            return []
        } else {
            return [newSupplierDetail?.type_info]
        }
    }, [newSupplierDetail])

    return (
        <div>
            <Table
                className="supplier-type"
                columns={cloumns as any}
                data={data}
                scroll={{ x: true, y: data.length ? 141 : 170 }}
                emptyText={
                    <div className="supplier-empty ">
                        <Empty imageNode={<NoData />} text={'暂无数据'} />
                    </div>
                }
            />
        </div>
    )
}

export default SupplierType;
